import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useRecoveryService } from 'app/utils/services/recoveryService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';

const useRecovery = () => {
  const { t } = useTranslation();
  const [emailInput, setEmailInput] = useState<string>('');
  const location = useLocation();
  const data = location.state;

  useEffect(() => {
    if (data?.email.length > 0) {
      setEmailInput(data?.email);
    }
  }, []);

  const { isLoadingRecovery, dataRecovery, recoveryMutation } = useRecoveryService();
  const { handleRedirect } = useRedirectWithFormId();
  const { handleSubmit, register } = useForm();

  useEffect(() => {
    if (dataRecovery !== undefined) {
      handleRedirect(dataRecovery);
    }
  }, [dataRecovery]);

  const handleChangeEmail = (event: any) => {
    setEmailInput(event.target.value);
  };

  const handleOnSubmit = () => {
    recoveryMutation({
      data: {
        email: emailInput,
      },
      url: `${data?.path_url}?business_key=${data?.business_key}`,
    });
  };

  const handleSubmitForm = handleSubmit(handleOnSubmit);

  return { t, isLoadingRecovery, data, dataRecovery, emailInput, register, handleChangeEmail, handleSubmitForm };
};

export default useRecovery;
